const refineBrxFacetsArgs = (facets) => {
  const enhancedBrefineBrxFacetsArgsResponse =
    facets &&
    facets.map((facet) => {
      return {
        delimitingCharacter: ">",
        facetId: facet?.facetId,
        field: facet?.facetId,
        title: facet.dname,
        filterFacetCount: facet?.filterFacetCount,
        numberOfValues: facet?.numberOfValues,
        injectionDepth: 1000,
        type: "specific",
        currentValues: [],
      };
    });
  return enhancedBrefineBrxFacetsArgsResponse;
};
export default refineBrxFacetsArgs;
